import { BaseNode } from './BaseNode';

export function CodeNode({ data }: { data: { label: string; alias?: string; code?: string } }) {
  const firstLine = data.code?.split('\n').find(l => l.trim())?.trim();

  return (
    <BaseNode
      type="code"
      label={data.label}
      alias={data.alias ? `${data.alias}.…` : undefined}
      lines={[{ text: firstLine, mono: true }]}
    />
  );
}
